import { render, staticRenderFns } from "./TxBuilder.vue?vue&type=template&id=5bb1a344&scoped=true"
import script from "./TxBuilder.vue?vue&type=script&lang=ts"
export * from "./TxBuilder.vue?vue&type=script&lang=ts"
import style0 from "./TxBuilder.vue?vue&type=style&index=0&id=5bb1a344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb1a344",
  null
  
)

export default component.exports